<template>
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">{{ isEditing ? 'Editar Unidad' : 'Crear Unidad' }}</h4>
            <p class="card-category">
              {{ isEditing ? 'Modifique los datos de la unidad' : 'Complete el formulario para crear una nueva unidad' }}
            </p>
          </div>
          <div class="card-body">
            <div v-if="loading" class="text-center">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Cargando...</span>
              </div>
            </div>
            
            <form v-else @submit.prevent="saveUnidad">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Sigla</label>
                    <input 
                      type="text" 
                      class="form-control" 
                      v-model="form.codigo" 
                      :class="{ 'is-invalid': errors.codigo }"
                    >
                    <div v-if="errors.codigo" class="invalid-feedback">
                      {{ errors.codigo[0] }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Nombre Unidad Organizacional</label>
                    <input 
                      type="text" 
                      class="form-control" 
                      v-model="form.nombre_unidad" 
                      :class="{ 'is-invalid': errors.nombre_unidad }"
                    >
                    <div v-if="errors.nombre_unidad" class="invalid-feedback">
                      {{ errors.nombre_unidad[0] }}
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Estado</label>
                    <select 
                      class="form-select" 
                      v-model="form.estado" 
                      :class="{ 'is-invalid': errors.estado }"
                    >
                      <option value="activo">Activo</option>
                      <option value="inactivo">Inactivo</option>
                    </select>
                    <div v-if="errors.estado" class="invalid-feedback">
                      {{ errors.estado[0] }}
                    </div>
                  </div>
                </div>
              </div>
              
              
              <div class="row">
                <div class="col-md-12 text-end">
                  <router-link to="/unidad" class="btn btn-secondary">
                    Cancelar
                  </router-link>
                  <button type="submit" class="btn btn-primary" :disabled="saving">
                    {{ saving ? 'Guardando...' : 'Guardar' }}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { ref, computed, onMounted } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import axios from 'axios';
  import Swal from 'sweetalert2';
  //import { useSwal } from 'sweetalert2';
  
  export default {
    setup() {
      const route = useRoute();
      const router = useRouter();
      //const swal = useSwal();
      
      const form = ref({
        codigo: '',
        nombre_unidad: '',
        estado: 'activo'
      });
      
      const loading = ref(true);
      const saving = ref(false);
      const errors = ref({});
      
      const unidadId = computed(() => {
        return route.params.id;
      });
      
      const isEditing = computed(() => {
        return !!unidadId.value;
      });
      
      const fetchUnidad = async () => {
        if (!isEditing.value) {
          loading.value = false;
          return;
        }
        
        try {
          const response = await axios.get(`/unidad/edit/${unidadId.value}`);
          const unidad = response.data.unidad;
          
          form.value = {
            codigo: unidad.codigo,
            nombre_unidad: unidad.nombre_unidad,
            estado: unidad.estado
          };
        } catch (error) {
          console.error('Error al cargar unidad:', error);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'No se pudo cargar la unidad'
          });
          router.push('/unidad');
        } finally {
          loading.value = false;
        }
      };
      
      const saveUnidad = async () => {
        saving.value = true;
        errors.value = {};
        
        try {
          let response;
          
          if (isEditing.value) {
            response = await axios.post(`/unidad/update/${unidadId.value}`, form.value);
          } else {
            response = await axios.post('/unidad/save/', form.value);
          }
          
          Swal.fire({
            icon: 'success',
            title: 'Éxito',
            text: response.data.message
          });
          
          router.push('/unidad');
        } catch (error) {
          console.error('Error al guardar unidad:', error);
          
          if (error.response?.status === 422) {
            errors.value = error.response.data.errors;
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: error.response?.data?.message || 'No se pudo guardar unidad'
            });
          }
        } finally {
          saving.value = false;
        }
      };
      
      onMounted(async () => {
        await Promise.all([fetchUnidad()]);
      });
      
      return {
        form,
        loading,
        saving,
        errors,
        isEditing,
        saveUnidad
      };
    }
  };
  </script>
  
  <style scoped>
  .roles-container {
    border: 1px solid #e9ecef;
    padding: 10px;
    border-radius: 4px;
    max-height: 200px;
    overflow-y: auto;
  }
  </style>